"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadMore = function LoadMore(_ref) {
  var isRequesting = _ref.isRequesting,
      onLoadMore = _ref.onLoadMore;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    sx: {
      display: 'flex',
      justifyContent: 'center',
      height: '25px',
      '&:hover': {
        cursor: 'pointer',
        '& p': {
          fontWeight: 700
        }
      },
      '&:active': {
        '& p': {
          opacity: 0.8
        }
      }
    }
  }, isRequesting ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    size: 20
  }) : /*#__PURE__*/_react.default.createElement(_material.Typography, {
    role: "button",
    "aria-label": "load-more",
    sx: {
      fontWeight: 500
    },
    onClick: onLoadMore
  }, t('load_more'), "..."));
};

var _default = LoadMore;
exports.default = _default;